const FIREBASE_ERROR_CODE = {
  userNotFound: 'auth/user-not-found',
  wrongPassword: 'auth/wrong-password',
};

export default FIREBASE_ERROR_CODE;
